import { ProfileSideNav } from "@/features/settings/components/profile-side-nav";
import { ProfileTab } from "@/features/settings/components/tabs/profile-tab";

/** Standalone Profile page (reached from the header account menu): a left rail
 * (title + in-page nav) beside the identity hero, profile/preferences and
 * security sections. */
export default function ProfilePage() {
  return (
    <div className="flex flex-col gap-6 xl:flex-row xl:items-start">
      <aside className="xl:sticky xl:top-[88px] xl:w-[250px] xl:shrink-0">
        <ProfileSideNav />
      </aside>
      <div className="min-w-0 flex-1">
        <ProfileTab />
      </div>
    </div>
  );
}
